import {useMutation, useQuery} from "@apollo/react-hooks";
import {makeStyles} from '@material-ui/core/styles';
import React, {useEffect} from 'react';
import {DELETE_TEAM_MEMBER, GET_TEAM_MEMBERS,} from "../../../database/queries/teamMemberQueries";
import MaterialTable from "material-table";
import tableIcons from "../../../constants/tableIcons";
import {SizeMe} from "react-sizeme";
import {notify} from "../../../utils/notify";
import useLayoutStore from "../../../layoutStore";
import Moment from "react-moment";
import CalendarStrings from "../../../constants/calendarStrings";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    navigation: {
        marginBottom: 0,
    },
    iFrameNavigation: {
        marginBottom: 0,
        minHeight: 0,
    },
    toolbar: {
        marginBottom: 0
    },
    iFrameToolbar: {
        marginBottom: 0,
        minHeight: 0
    },
    grow: {
        flexGrow: 1,
    },
}));

const TeamMembers = props => {
    const classes = useStyles();
    const [globalLayoutState] = useLayoutStore();

    const {loading: getTeamMembersLoading, error: getTeamMembersError, data: getTeamMembersData, refetch: getTeamMembersRefetch} = useQuery(GET_TEAM_MEMBERS, {
        skip: !props.editId,
        variables: {
            teamId: props.editId,
            orderList: []
        },
    });

    const [deleteTeamMember, {error: deleteTeamMemberError}] = useMutation(DELETE_TEAM_MEMBER);

    const columns = [
        {title: 'User', field: 'user.displayName'},
        {title: 'Email', field: 'user.email'},
        {
            title: 'Joined',
            render: r => {
                return (
                    <Moment calendar={CalendarStrings}>{r.createdAt}</Moment>
                )
            },
        },
    ];

    useEffect(() => {
        if (deleteTeamMemberError) notify('deleteTeamMemberError', 'error', deleteTeamMemberError.message);
        if (getTeamMembersError) notify('getTeamMembersError', 'error', getTeamMembersError.message);
    }, [deleteTeamMemberError, getTeamMembersError]);

    // useEffect(() => {
    //     getTeamMembersRefetch();
    // }, [getTeamMembersRefetch]);

    useEffect(() => {
    }, [globalLayoutState.tabBarHeight]);

    if (getTeamMembersLoading) return <p>Loading ...</p>;
    if (getTeamMembersError) return `Error! ${getTeamMembersError.message}`;

    return (
        <div className={classes.root}>
            {getTeamMembersData && getTeamMembersData.teamMembers && (
                <div>
                    <SizeMe>
                        {({size}) => {
                            let height = size.height;
                            if (!height) height = window.innerHeight;
                            const tableOptions = {
                                maxBodyHeight: height - (globalLayoutState.tabBarHeight + 50),
                                padding: 'dense',
                                header: true,
                                paging: false,
                                showTitle: true,
                                search: true,
                                actionsColumnIndex: -1
                            };

                            return (
                                <MaterialTable
                                    icons={tableIcons}
                                    title="Team Members"
                                    columns={columns}
                                    data={getTeamMembersData.teamMembers}
                                    options={tableOptions}
                                    editable={{
                                        onRowDelete: oldData =>
                                            new Promise((resolve, reject) => {
                                                setTimeout(() => {
                                                    deleteTeamMember({
                                                        variables: {
                                                            deleteTeamMemberId: oldData.teamMemberId,
                                                        }
                                                    }).then(() => {
                                                        getTeamMembersRefetch();
                                                        resolve();
                                                    }).catch((e) => {
                                                        reject();
                                                    });
                                                    resolve()
                                                }, 1000)
                                            }),
                                    }}
                                />
                            );
                        }}
                    </SizeMe>
                </div>
            )}
        </div>
    )
};

export default TeamMembers
